import React from 'react';
import { GraduationCap, MapPin } from 'lucide-react';
import { Button } from '@/components/ui/Button';

export type DayScheduleColumnAxis = 'court' | 'coach';

const STORAGE_KEY = 'courtsync.schedule.dayColumnAxis';

export function readStoredDayColumnAxis(): DayScheduleColumnAxis {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'court' || stored === 'coach') return stored;
  } catch {
    /* localStorage unavailable */
  }
  return 'court';
}

export function persistDayColumnAxis(axis: DayScheduleColumnAxis): void {
  try {
    localStorage.setItem(STORAGE_KEY, axis);
  } catch {
    /* localStorage unavailable */
  }
}

export function DayColumnAxisToggle({
  value,
  onChange,
}: {
  value: DayScheduleColumnAxis;
  onChange: (axis: DayScheduleColumnAxis) => void;
}) {
  return (
    <div
      className="inline-flex shrink-0 items-center overflow-hidden rounded-lg border border-border bg-background shadow-sm"
      role="group"
      aria-label="Group day view by"
    >
      <Button
        type="button"
        variant={value === 'court' ? 'default' : 'ghost'}
        size="sm"
        className="h-8 rounded-none px-2.5 gap-1.5"
        aria-pressed={value === 'court'}
        onClick={() => onChange('court')}
      >
        <MapPin className="h-3.5 w-3.5" aria-hidden />
        Court
      </Button>
      <Button
        type="button"
        variant={value === 'coach' ? 'default' : 'ghost'}
        size="sm"
        className="h-8 rounded-none border-l border-border px-2.5 gap-1.5"
        aria-pressed={value === 'coach'}
        onClick={() => onChange('coach')}
      >
        <GraduationCap className="h-3.5 w-3.5" aria-hidden />
        Coach
      </Button>
    </div>
  );
}
